import _ from 'lodash'
const MODAL_CONFIG = {
    modals: _.select( '.c-modals' ),
    closer: _.select( '.c-modals__closer' ),
    triggers: _.selectAll( '.c-modal__trigger' )
}

export default MODAL_CONFIG